export class Answer {
  content?: string;
  question?: string;
  questionType?: string;
  linkedQuestion?: string;
  customContent?: string;
  uniqid?: string;
}
